import moment from 'moment';

export type EmploymentDataStaff = {
  id: {
    companyCode: string,
    staffCode: string,
    applyStartDate: Date,
  },
  applyEndDate: Date,
  employmentId: string,
  employmentCode: string,
  employmentName: string,
}

export class EmploymentDataStaffDomain {
  constructor(private rawData: EmploymentDataStaff) {
    // do nothing
  }

  get applyStartDate(): Date {
    return this.rawData.id.applyStartDate;
  }

  get applyStartDateStr(): string {
    return moment(this.rawData.id.applyStartDate).format('YYYY年MM月DD日');
  }

  set applyStartDate(applyStartDate: Date) {
    this.rawData.id.applyStartDate = applyStartDate;
  }

  get applyEndDate(): Date {
    return this.rawData.applyEndDate;
  }

  get applyEndDateStr(): string {
    return moment(this.rawData.applyEndDate).format('YYYY年MM月DD日');
  }

  set applyEndDate(applyEndDate: Date) {
    this.rawData.applyEndDate = applyEndDate;
  }

  get employmentId(): string {
    return this.rawData.employmentId;
  }

  set employmentId(employmentId: string) {
    this.rawData.employmentId = employmentId;
  }

  get employmentCode(): string {
    return this.rawData.employmentCode;
  }

  set employmentCode(employmentCode: string) {
    this.rawData.employmentCode = employmentCode;
  }

  get employmentName(): string {
    return this.rawData.employmentName;
  }

  set employmentName(employmentName: string) {
    this.rawData.employmentName = employmentName;
  }
}
